import React from 'react'
import Body from '../Body'
import ModelsSection from '../Models/ModelsSection'

function Home() {
  return (
    <div>
        <Body />
        <ModelsSection />
    </div>

  )
}

export default Home